import React, { useState, useEffect } from 'react';
import Adjuntos from '../../Adjuntos';
import AutocompleteListasDeCorreos from "./AutocompleteListasDeCorreos";
import AlertMessage from '../../../../Alias/AlertMessage';
import ComponenteDrafter from "./ComponenteDrafter";
import { useDifusiones } from "../../../context/DifusionesContext";
import { useBody } from '../../../../Body/state/BodyContext';
import { TextFieldRojo } from "../../../../App";
import { MAX_SIZE_FILE, MAX_SIZE_FILES } from '../../../../Contantes/Constantes';
import {
    Box,
    Slide,
    FormControl,
    Typography,
    Skeleton,
    Divider,
} from '@mui/material';

export default function RedactarMail({ images, setImages, direccion, alert, setAlert, form, setForm, setBodyHtml, bodyHtml, onLoadingChange }) {
    const { obtenerListas } = useDifusiones()
    const { setMessage } = useBody();
    const [listasNoSeleccionadas, setListasNoSeleccionadas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [asuntoTocado, setAsuntoTocado] = useState(false);

    useEffect(() => {
        async function fetchListas() {
            setLoading(true);
            onLoadingChange(true);
            try {
                const res = await obtenerListas(form.area);
                setListasNoSeleccionadas(res);
            } catch (error) {
                console.error("Error al traer listas:", error);
                setMessage("Hubo un error al traer las listas");
            } finally {
                setLoading(false);
                onLoadingChange(false);
            }
        }

        fetchListas();
    }, []);
    

    const handleChangeAsunto = (event) => {
        setForm(prevForm => ({
            ...prevForm,
            asunto: event.target.value,
        }));
    };

    const agregarAdjuntos = (file) => {
        setForm({
            ...form,
            adjuntos: file
        })
    }

    const agregarListasSeleccionadas = (listas) => {
        const listasQuitadas = form.listasSeleccionadas.filter(l => !listas.includes(l));
        const nuevasNoSeleccionadas = listasNoSeleccionadas
            .filter(l => !listas.includes(l))
            .concat(listasQuitadas)
            .sort();

        setListasNoSeleccionadas(nuevasNoSeleccionadas);
        setForm({
            ...form,
            listasSeleccionadas: listas,
        });
    };

    return (
        <Slide direction={direccion} in={true} mountOnEnter unmountOnExit>
            <div>
                <AlertMessage alert={alert} setAlert={setAlert} />
                <FormControl fullWidth sx={{ m: 1 }}>
                    <TextFieldRojo
                        id="outlined-read-only-input"
                        label="Alias"
                        name="alias"
                        value={form.alias}
                        sx={{ my: 1 }}
                        InputProps={{
                            readOnly: true,
                            disabled: true
                        }} />
                    <TextFieldRojo
                        placeholder="Asunto"
                        id="my-input"
                        variant="outlined"
                        label='Asunto'
                        name="asunto"
                        value={form.asunto}
                        sx={{ my: 1 }}
                        onChange={handleChangeAsunto}
                        onBlur={() => setAsuntoTocado(true)}
                        error={
                            asuntoTocado
                                ? form.asunto.length < 3 || form.asunto.length > 255
                                : alert?.message === 'El asunto debe tener entre 3 y 255 caracteres'
                        }
                        helperText={
                            <Box component="span" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span>
                                    {asuntoTocado && (form.asunto.length < 3 || form.asunto.length > 255)
                                        ? 'El asunto debe tener entre 3 y 255 caracteres'
                                        : ''}
                                </span>
                                <span style={{ color: form.asunto.length > 255 ? 'red' : 'inherit' }}>
                                    {form.asunto.length}/255
                                </span>
                            </Box>
                        }
                    />

                    <Divider sx={{ my: 2 }}>
                        <Typography variant="caption" color="text.secondary">Destinatarios</Typography>
                    </Divider>

                    {loading ?
                        <Box sx={{ mt: 1, mb: 2 }}>
                            <Skeleton
                                variant="rounded"
                                height={56}
                                animation="wave"
                                sx={{ '&::after': { animationDuration: '0.8s' } }}
                            />
                        </Box>
                        :
                        <Box sx={{ my: 1, display: 'flex' }}>
                            <AutocompleteListasDeCorreos
                                listasSeleccionadas={form.listasSeleccionadas}
                                listasNoSeleccionadas={listasNoSeleccionadas}
                                agregarListasSeleccionadas={agregarListasSeleccionadas}
                                alert={alert}
                            />
                        </Box>
                    }

                    <Divider sx={{ my: 2 }}>
                        <Typography variant="caption" color="text.secondary">Contenido del mensaje</Typography>
                    </Divider>

                    <ComponenteDrafter
                        sizeFile={MAX_SIZE_FILE}
                        sizeFiles={MAX_SIZE_FILES}
                        bodyHtml={bodyHtml}
                        setbodyHtml={(value) => setBodyHtml(value)}
                        images={images}
                        setImages={setImages}
                    />

                    <Divider sx={{ my: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Typography variant="caption" color="text.secondary">Archivos adjuntos</Typography>
                        </Box>
                    </Divider>

                    <Adjuntos
                        sizeFile={MAX_SIZE_FILE}
                        sizeFiles={MAX_SIZE_FILES}
                        files={form.adjuntos}
                        agregarAdjuntos={agregarAdjuntos}
                    />
                </FormControl>
            </div>
        </Slide>
    );
}